import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { styled } from '@mui/material/styles';

const Item = styled(Box)(({ theme }) => ({
    color: theme.palette.white.main,
    p: 1,
    borderRadius: 1,
    fontSize: 19,
    fontWeight: '700',
    minHeight: '60px',
}));

//use the props of status to check if there was a previous booking on this day
//That will allow you to see previously hired days
const DayPaper = styled(Paper, {
    shouldForwardProp: prop => prop !== 'previous' && prop !== 'isToday',
    name: 'DayPaper',
    overridesResolver: (props, styles) => [
        props.previous === false && styles.paperNoPad,
        props.previous === true &&
            props.status !== 'Available' &&
            styles.oldBooking,
        props.previous === true && props.isToday === true && styles.paperToday,
        props.previous === true &&
            props.isToday === false &&
            styles.paperDisabled,
    ],
})(({ theme }) => ({}));

const NumberTypography = styled(Typography, {
    shouldForwardProp: prop => prop !== 'isToday',
    name: 'numberTypography',
    slot: 'Root',
    overridesResolver: (props, styles) => [
        styles.root,
        props.isToday === true && styles.calNumberToday,
    ],
})(({ theme }) => ({}));

const BookingTypography = styled(Typography, {
    shouldForwardProp: prop => prop !== 'previous' && prop !== 'status',
    name: 'bookingTypography',
    slot: 'Root',
    overridesResolver: (props, styles) => [
        styles.root,
        props.status === 'Confirmed' &&
            props.previous === false &&
            styles.appointmentConfirmed,
        props.status === 'Confirmed' &&
            props.previous === true &&
            styles.oldAppointmentConfirmed,
        props.status === 'On Hold' &&
            props.previous === true &&
            styles.oldAppointmentOnHold,
        props.status === 'On Hold' &&
            props.previous === false &&
            styles.appointmentOnHold,

        props.status === 'Available' &&
            props.previous === false &&
            styles.appointment,
        props.status === 'Available' &&
            props.previous === true &&
            styles.oldAppointment,
    ],
})(({ theme }) => ({}));

const DayItemComponentFull = props => {
    const disabled = props.previous || props.disabled;

    const displayFormattedDate = format(
        props.todaysAppt.status === 'Confirmed' &&
            typeof props.todaysAppt.bookingStartDate !== 'undefined'
            ? parseISO(props.todaysAppt.bookingStartDate)
            : parseISO(props.todaysAppt.startDate),
        'haaaaa'
    );

    return (
        <Item key={props.key}>
            <DayPaper
                previous={disabled}
                isToday={props.isToday}
                data-cy="day-full"
            >
                <NumberTypography
                    isToday={props.isToday}
                    align="left"
                    color="textPrimary"
                >
                    {props.formattedDate}
                </NumberTypography>
                <Box sx={{ padding: 0 }}>
                    {/* {disabled || props.isToday ? (
                        <Typography
                            noWrap={true}
                            sx={{
                                'background-color': 'rgb(40 182 195 / 44%)',
                                'border-radius': '3px',
                                color: 'white',
                                width: '100%',
                                padding: '2px',
                            }}
                        >
                            {displayFormattedDate +
                                ' ' +
                                props.todaysAppt.status}
                        </Typography>
                    ) : ( */}
                    <BookingTypography
                        noWrap={true}
                        status={props.todaysAppt.status}
                        previous={props.previous}
                        onClick={props.toggleDrawer(
                            props.direction,
                            props.todaysAppt,
                            true,
                            props.type,
                            props.previous
                        )}
                        data-cy="day-status"
                    >
                        {displayFormattedDate + ' ' + props.todaysAppt.status}
                    </BookingTypography>
                    {/* )} */}
                </Box>
            </DayPaper>
        </Item>
    );
};
export default DayItemComponentFull;
